import { Component, ElementRef, OnInit } from '@angular/core';
import { ProductService } from '../../services/productservice';
import { environment } from '@env/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@app/auth/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from 'src/services/loader.service';
import { Title } from '@angular/platform-browser';
import { SearchService } from 'src/services/search-service.service';

@Component({
  selector: 'tokencheck',
  templateUrl: './tokencheck.component.html',
  styleUrls: ['./tokencheck.component.scss'],
})
export class TokencheckComponent implements OnInit {
  public privacyDetails: any = { bannerImage: null, bannerTitle: null, content: null };
  images: any = [];
  data: any = [];
  hours: any = [];
  geocodes: any[];
  point: any[];
  city: string;
  user_id: number;
  timer: string;
  token: string;
  weather: string;
  weatherimg: string;
  todaydate: Date;
  status: string;
  msg: string;
  currentUrl: any;
  listItem: any = [];
  bannerImage: any;
  activeIndex: any;
  displayCustom: boolean;
  userName: string;

  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5,
    },
    {
      breakpoint: '768px',
      numVisible: 3,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
    },
  ];

  constructor(
    public productService: ProductService,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private translate: TranslateService,
    private loaderService: LoaderService,
    private titleService: Title,
    private searchService: SearchService
  ) {}

  ngOnInit(): void {
    this.currentUrl = this.router.url;
    const currentRoute = 'token-check';
    this.getListType(currentRoute);

    this.route.paramMap.subscribe((paramMap) => {
      this.user_id = Number(paramMap.get('user_id'));
      this.timer = paramMap.get('time');
      this.token = paramMap.get('token');
      if (this.user_id != null && this.timer != null && this.timer != null) {
        this.productService.tockencheck(this.user_id, this.timer, this.token).then((tdata) => {
          if (tdata) {
            this.msg = tdata.message;
            this.status = tdata.status;
            this.userName = tdata.data.name;
            this.productService.setSessionName(this.userName);
            this.productService.setSessionUserId(this.user_id);
          }
        });
      }
    });
  }

  getListType(selectedCat: any) {
    this.searchService.getListType(selectedCat).subscribe((data) => {
      const refListItem = data;
      this.listItem = [];
      this.listItem.push(refListItem);
      if (this.listItem[0].bannerImage) {
        this.bannerImage = this.listItem[0].bannerImage;
      } else {
        this.bannerImage = '../../../assets/images/NoImage.jpg';
      }
      this.images.push(this.bannerImage);
      this.titleService.setTitle(this.listItem[0].bannerTitle + ' ' + '| The Seychelles Islands');
    });
  }

  imageClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }
}
